// keymap.js - Tastenbelegung des Editors (Alt-Shortcuts) plus Default- und History-Keymap

import { keymap } from "@codemirror/view";
import { defaultKeymap, historyKeymap } from "@codemirror/commands";

export function appKeymap() {
  return keymap.of([
    // New befund tab shortcut (Alt+B)
    {
      key: "Alt-b",
      run: (view) => {
        // Trigger new tab via button click
        const newTabBtn = document.getElementById('btn-new-tab');
        if (newTabBtn) {
          newTabBtn.click();
          return true;
        }
        return false;
      }
    },
    // Logic check shortcut (Alt+X)
    {
      key: "Alt-x",
      run: (view) => {
        // Trigger logic check via button click
        const logicCheckBtn = document.getElementById('btn-logic-check');
        if (logicCheckBtn) {
          logicCheckBtn.click();
          return true;
        }
        return false;
      }
    },
    // Grammar check shortcut (Alt+Z)
    {
      key: "Alt-z",
      run: (view) => {
        // Trigger grammar check via button click to sync button state
        const grammarCheckBtn = document.getElementById('btn-grammar-check');
        if (grammarCheckBtn) {
          grammarCheckBtn.click();
          return true;
        }
        return false;
      }
    },
    // Copy to Word shortcut (Alt+C)
    {
      key: "Alt-c",
      run: (view) => {
        // Trigger copy to word via button click
        const copyToWordBtn = document.getElementById('btn-copy-to-word');
        if (copyToWordBtn) {
          copyToWordBtn.click();
          return true;
        }
        return false;
      }
    },
    // Execute selected tools shortcut (Alt+E)
    {
      key: "Alt-e",
      run: (view) => {
        const executeBtn = document.getElementById('btn-execute-selected');
        if (executeBtn) {
          executeBtn.click();
          return true;
        }
        return false;
      }
    },
    // Tool shortcuts Alt+1 bis Alt+3
    {
      key: "Alt-1",
      run: (view) => {
        const btn = document.getElementById('btn-grammar-check-dropdown');
        if (btn) {
          btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          return true;
        }
        return false;
      }
    },
    {
      key: "Alt-2",
      run: (view) => {
        const btn = document.getElementById('btn-format-check-dropdown');
        if (btn) {
          btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          return true;
        }
        return false;
      }
    },
    {
      key: "Alt-3",
      run: (view) => {
        const btn = document.getElementById('btn-logic-check-dropdown');
        if (btn) {
          btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          return true;
        }
        return false;
      }
    },
    ...defaultKeymap,
    ...historyKeymap
  ]);
}
